module.exports = __webpack_public_path__ + "img/dm.c91ffb53.svg";